import { Page } from "@/models/page-models/Page";

export const SparePartsCreate: Page = {
  "path": "spare-parts/create",
  "name": "Create Spare Parts",
  "props": {
    "data": {
      "title": "Create Spare Part",
      "printable": "FALSE",
      "url": "spare-parts/create",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.description",
                  "label": "Description",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "formData.specification",
                  "label": "Specification",
                  "disabled": "FALSE"
                },
                {
                  "type": "dropdown",
                  "variable": "formData.category",
                  "label": "Category",
                  "disabled": "FALSE",
                  "items": "[\"Air\",\"Air Hose\",\"Battery\",\"Bearing\",\"Belt\",\"Bit\",\"Blade\",\"Board\",\"Bolt\",\"Box\",\"Breaker\",\"Brush\",\"Bulb\",\"CARBON BRUSH\",\"Cable\",\"Capacitor\",\"Circlip\",\"Clip\",\"Cloth\",\"Coating\",\"Coil\",\"Compressor\",\"Connector\",\"Contactor\",\"Controller\",\"Coolent\",\"Coupling\",\"Cover\",\"Die Drier\",\"Electrode\",\"Fan\",\"Fischer\",\"Flange\",\"Fuild\",\"Fuse\",\"Gas\",\"Gasket\",\"Gloves\",\"Glue\",\"Greese\",\"Griding\",\"Grinder\",\"Hose\",\"Joint\",\"Lamp\",\"Lifter\",\"Light\",\"Lock\",\"Lug\",\"Mask\",\"Mat\",\"Meter\",\"Motor\",\"Mount\",\"Nail\",\"Net\",\"Nut\",\"0-Ring\",\"011\",\"Oil\",\"PCB\",\"Pak\",\"Seal\",\"Paper\",\"Pipe\",\"Piston\",\"Plier\",\"Plug\",\"Plug Socket\",\"Pneumatic\",\"Potentiometer\",\"Power\",\"R 22\",\"Rectifier\",\"Reducer\",\"Regulator\",\"Relay\",\"Resistor\",\"Roll\",\"Roller\",\"Rope\",\"Screw\",\"Sensor\",\"Sheet\",\"Shutter\",\"Silencer\",\"Socket\",\"Spaner\",\"Sprayer\",\"Spring\",\"Strip\",\"Switch\",\"Tape\",\"Thermocouple\",\"Transducer\",\"Transformer\",\"Tyre\",\"Valve\",\"WD40\",\"Washer\",\"Weldilet\",\"Wheel\",\"Wrench\",\"Valve\",\"WD40\",\"Washer\",\"Weldilet\",\"Wheel\",\"Wrench\",\"connector\",\"key\",\"oil\",\"rod\",\"tie\",\"wool\"]",
                  "dropdownType": "static"
                }
              ],
              "disabled": "fn(LOGICAL,{{formData._id}},==,{{__params.sparePartId}})"
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.unitPrice",
                  "label": "Unit Price",
                  "unit": "SAR",
                  "disabled": "FALSE"
                },
                {
                  "type": "dropdown",
                  "variable": "formData.unit",
                  "label": "Unit",
                  "disabled": "FALSE",
                  "items": "[\"BKS\",\"BOX\",\"BTL(Bottle)\",\"CAN\",\"DOZ\",\"DRM\",\"FT\",\"GAL(GALLON)\",\"GMS\",\"HRS\",\"KGS\",\"LTR\",\"MTR\",\"NO.\",\"NOD\",\"NOS\",\"NRS\",\"PAD\",\"PCS\",\"PKT\",\"PR\",\"QRT\",\"RMS(Reams)\",\"ROL\"]",
                  "dropdownType": "static"
                }
              ],
              "disabled": "fn(LOGICAL,{{formData._id}},==,{{__params.sparePartId}})"
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Create Spare Part",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "name": "saveSparePart"
                    }
                  ],
                  "disabled": "FALSE",
                  "color": "primary"
                }
              ]
            }
          ],
          "type": "genericGroup"
        }
      ],
      "useMaxPageWidth": false
    },
    "functions": [
      {
        "name": "saveSparePart",
        "type": "fnSubmit",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v2/sparepart",
        "arg2Key": "postData",
        "arg2Value": "formData",
        "arg3Key": "redirectUrl",
        "arg3Value": "/spare-parts"
      }
    ]
  },
  "forRole": "COMMERCIAL_PURCHASER,COMMERCIAL_MANAGER",
  "visible": false,
  "routerPriority": 100
}